import { useCallback, useEffect, useState } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { enablePush, pushSupported } from "@/lib/push";

const MSG = {
  unsupported: "Su questo telefono le notifiche non possono arrivare. Su iPhone apri l'app dall'icona sulla schermata Home (Condividi → Aggiungi a Home).",
  denied: "Le notifiche di Coach2Go sono bloccate nelle impostazioni del telefono. Riattivale da Impostazioni → Notifiche, poi torna qui.",
  lost: "Le notifiche risultano attive, ma questo telefono non è più collegato: per questo potrebbero non arrivare.",
};

async function checkDevice() {
  if (!pushSupported()) return "unsupported";
  if (Notification.permission === "denied") return "denied";
  const reg = await Promise.race([navigator.serviceWorker.ready, new Promise((r) => setTimeout(() => r(null), 4000))]);
  const sub = reg && (await reg.pushManager.getSubscription());
  if (!sub || Notification.permission !== "granted") return "lost";
  const { data } = await api.post("/push/status", { endpoint: sub.endpoint });
  return data.registered ? "ok" : "lost";
}

export const PushHealth = ({ enabled, className = "" }) => {
  const [state, setState] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = useCallback(() => (enabled ? checkDevice().then(setState).catch(() => setState(null)) : setState(null)), [enabled]);
  useEffect(() => { run(); }, [run]);

  if (!state || state === "ok") return null;
  const fix = async () => {
    setBusy(true);
    try {
      await enablePush();
      toast.success("Notifiche riattivate su questo telefono");
      await run();
    } catch (e) {
      toast.error(e.message || "Impossibile riattivare le notifiche");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-testid="push-health-warning" data-state={state} className={`rounded-2xl border border-[#F59E0B]/40 bg-[#F59E0B]/10 p-4 ${className}`}>
      <p className="flex gap-2 text-base text-[#FCD34D]"><AlertTriangle size={18} className="mt-0.5 shrink-0" />{MSG[state]}</p>
      {state === "lost" && (
        <button onClick={fix} disabled={busy} data-testid="push-health-fix-button" className="btn-gold mt-3 inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm uppercase tracking-wide disabled:opacity-60">
          <RefreshCw size={14} className={busy ? "animate-spin" : ""} /> Riattiva su questo telefono
        </button>
      )}
    </div>
  );
};
